import {
  Contact
} from '../index';

declare var Object: any;
export interface EmailAddressInterface {
  "label"?: string;
  "value": string;
  "default"?: boolean;
  "order"?: number;
  "dtime"?: Date;
  "id"?: number;
  "contactId"?: number;
  contact?: Contact;
}

export class EmailAddress implements EmailAddressInterface {
  "label": string;
  "value": string;
  "default": boolean;
  "order": number;
  "dtime": Date;
  "id": number;
  "contactId": number;
  contact: Contact;
  constructor(data?: EmailAddressInterface) {
    Object.assign(this, data);
  }

  /**
   * The name of the model represented by this $resource,
   * i.e. `EmailAddress`.
   */
  public static getModelName() {
    return "EmailAddress";
  }

  /**
  * This method creates an instance of EmailAddress for dynamic purposes.
  **/
  public static factory(data: EmailAddressInterface): EmailAddress{
    return new EmailAddress(data);
  }

  /**
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'EmailAddress',
      plural: 'EmailAddresses',
      path: 'EmailAddresses',
      idName: 'id',
      properties: {
        "label": {
          name: 'label',
          type: 'string'
        },
        "value": {
          name: 'value',
          type: 'string'
        },
        "default": {
          name: 'default',
          type: 'boolean',
          default: false
        },
        "order": {
          name: 'order',
          type: 'number',
          default: 0
        },
        "dtime": {
          name: 'dtime',
          type: 'Date'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "contactId": {
          name: 'contactId',
          type: 'number'
        },
      },
      relations: {
        contact: {
          name: 'contact',
          type: 'Contact',
          model: 'Contact',
          relationType: 'belongsTo',
                  keyFrom: 'contactId',
          keyTo: 'id'
        },
      }
    }
  }
}
